module.exports = __webpack_public_path__ + "static/media/om_faceshape_diamond.5cf77884.png";